import { useCallback, useMemo } from 'react';
import { Stack } from '@mui/material';
import { NumberInput } from '@common/components/inputs';
import { UserPreferenceName } from '@modules/userPreferences';
import { useUserPreference, useUpdateUserPreferences } from '@/modules/userPreferences/hooks';
import { SnackbarServiceFactory } from '@/modules/snackbar/service/SnackbarServiceFactory';
import { ResetUserPreferenceButton } from './ResetUserPreferenceButton';

const SNAPPING_THRESHOLD_MIN = 1;
const SNAPPING_THRESHOLD_MAX = 10000;

export const SnappingThresholdInput = () => {
  const value: number = useUserPreference(UserPreferenceName.CANVAS_SNAPPING_THRESHOLD);
  const { updateUserPreference } = useUpdateUserPreferences();
  const snackbarSvc = useMemo(
    () => SnackbarServiceFactory.getInstance().createSnackbarService(),
    [],
  );

  const onChange = useCallback(
    (next: number) => {
      if (next >= SNAPPING_THRESHOLD_MIN && next <= SNAPPING_THRESHOLD_MAX) {
        updateUserPreference(UserPreferenceName.CANVAS_SNAPPING_THRESHOLD, next);
        snackbarSvc.showMessage(
          'Snapping threshold updated. Refresh the page for it to take effect.',
        );
      }
    },
    [updateUserPreference, snackbarSvc],
  );

  return (
    <Stack direction='row' alignItems='center' spacing={0.5}>
      <NumberInput
        sx={{ width: '100%' }}
        value={value}
        onChange={onChange}
        minValue={SNAPPING_THRESHOLD_MIN}
        disabled={false}
      />
      <ResetUserPreferenceButton preference={UserPreferenceName.CANVAS_SNAPPING_THRESHOLD} />
    </Stack>
  );
};
